<template>
    <NoButtonModal :open="open" @close="$emit('cancel')">
      <button class="close-corner-x" type="button" @click.prevent="alertResponse('cancel')">
        <span class="material-icons-outlined dark-text">close</span>
      </button>
      <h1>Change Template Alert</h1>
      <p>Are you sure you want to change this template?</p>
      <button @click="alertResponse('cancel')" class="button secondary">Cancel</button>
      <button @click="alertResponse('handleChangeTemplate')" class="button primary">Proceed</button>
    </NoButtonModal>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';
    export default {
        name: 'AlertChangeTemplate',
        components: { NoButtonModal },
        props: {
            open: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            alertResponse(action) {
                if( action === 'handleChangeTemplate' ){
                    
                    this.$emit('handleChangeTemplate');
                }
                else {
                    this.$emit('cancel');
                }
            }
        }
    };
</script>
